import React from 'react';
import { Link } from 'react-router-dom';
import ProgressBar from './ProgressBar';
import styles from '../styles/stepCard.module.css';

export interface StepCardProps {
  stepNumber: number;
  title: string;
  description: string;
  status?: 'not-started' | 'in-progress' | 'completed';
  isLoggedIn: boolean;
  stepPath?: string;
  onStepClick?: () => void;
  onLoginClick?: () => void;
}

const StepCard: React.FC<StepCardProps> = ({ 
  stepNumber, 
  title, 
  description, 
  status = 'not-started', 
  isLoggedIn, 
  stepPath,
  onStepClick,
  onLoginClick
}) => {
  const getProgressValue = () => {
    switch (status) {
      case 'completed': return 100;
      case 'in-progress': return 50;
      default: return 0;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'completed': return 'Completed';
      case 'in-progress': return 'In Progress';
      default: return 'Not Started';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'completed': return '#28a745';
      case 'in-progress': return '#ffc107';
      default: return '#6c757d';
    }
  };

  const handleStepClick = () => {
    if (onStepClick) {
      onStepClick();
    }
  };

  const handleLoginClick = () => {
    if (onLoginClick) {
      onLoginClick();
    }
  };

  const renderStepButton = () => {
    const buttonContent = (
      <div className={styles.stepButtonContent}>
        <span className={styles.stepButtonNumber}>Step {stepNumber}</span>
        {isLoggedIn && (
          <span 
            className={styles.stepButtonStatus}
            style={{ backgroundColor: getStatusColor() }}
          >
            {getStatusText()}
          </span>
        )}
      </div>
    );

    if (stepPath) {
      return (
        <Link to={stepPath} className={styles.stepButton}>
          {buttonContent}
        </Link>
      );
    } else {
      return (
        <button onClick={handleStepClick} className={styles.stepButton}>
          {buttonContent}
        </button>
      );
    }
  };

  return (
    <div className={styles.stepCard}>
      {isLoggedIn ? (
        <div className={styles.stepActions}>
          {renderStepButton()}
        </div>
      ) : (
        <div className={styles.loginPrompt}>
          <p className={styles.loginText}>Sign in to track your progress</p>
          <button onClick={handleLoginClick} className={styles.loginButton}>
            Sign in
          </button>
        </div>
      )}
      <div className={styles.stepTitle}>{title}</div>
      <div className={styles.stepDescription}>{description}</div>
    </div>
  );
};

export default StepCard; 